import { useState } from "react";
import {
  Calendar,
  DayValue,
} from "@hassanmojab/react-modern-calendar-datepicker";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import { useSelector } from "react-redux";
import theme from "../../config/theme";

function PersianCalendar() {
  const [selectedDay, setSelectedDay] = useState<DayValue>(null);
  const { theme: themeMode } = useSelector((state: any) => state.globalState);
  const mode = themeMode === "light" ? theme.light : theme.dark;

  return (
    <div>
      <style>
        {`
            .customBackgroundColor{
            font-size: 0.65rem;
            }
            .Calendar__day{
            color: ${mode.color.textPrimary} ;
            }
            .Calendar__yearText{
            color: ${mode.color.textPrimary} ;
            }
            .Calendar__monthText{
            color: ${mode.color.textPrimary} ;
            }
            .-today{
            color: ${mode.color.textSuccess} !important;
            }
            `}
      </style>
      <div className="border border-[#AAAAAA] rounded-lg shadow-none">
        <Calendar
          value={selectedDay}
          onChange={setSelectedDay}
          locale="fa"
          calendarClassName="custom-persian-calendar customBackgroundColor shadow-none"
          shouldHighlightWeekends
        />
      </div>
    </div>
  );
}

export default PersianCalendar;
